import { Component, OnInit } from '@angular/core';
import { MdDialogRef } from '@angular/material';

@Component({
  selector: 'pui-prompt-dialog',
  templateUrl: './prompt-dialog.component.html',
  styleUrls: ['./prompt-dialog.component.scss' ],
})
export class PuiPromptDialogComponent implements OnInit {
  title: string;
  message: string;
  value: string;
  cancelButton: string = 'Cancel';
  acceptButton: string = 'Accept';

  constructor(private dialogRef: MdDialogRef<PuiPromptDialogComponent>) { }

  ngOnInit() {}

  cancel(): void {
    this.dialogRef.close(undefined);
  }

  accept(): void {
    this.dialogRef.close(this.value);
  }
}
